import React, {Component} from 'react';
import MonthSelector from './MonthSelector';
import Salary from 'components/Salary/Salary';
import WorkerSchedule from 'components/Schedule/WorkerSchedule';
import {
  fetchUserList,
  fetchSelectedUserInfo,
  fetchSessionConfig
} from 'actions/UserActions';

import {
  fetchAdjustmentTypeList
} from 'actions/SalaryActions.js';

import {
  fetchConstructionList
} from 'actions/ConstructionActions';
class MonthSchedulePanel extends Component {
  componentDidMount() {
    let {dispatch} = this.props;
    dispatch(fetchSessionConfig());
    dispatch(fetchUserList());
    dispatch(fetchSelectedUserInfo());
    dispatch(fetchAdjustmentTypeList());
    dispatch(fetchConstructionList());
  }

  render() {
    let {
      year,
      month,
      shiftRecord,
      dispatch,
      siteList,
      sessionConfig,
      loadingUserData,
      positionList,
      user
    } = this.props;

    return (
      <div className="panel panel-ws">
        <MonthSelector
          year={year}
          month={month}
          dispatch={dispatch}
          loadingUserData={loadingUserData} />

          {(loadingUserData? 
            <div className="panel-body">
              <div className="loading-msg">
                <h1>加載中...</h1>
              </div>
            </div>
          :
            <div className="panel-body">
              <Salary
                {...this.props} />
              <WorkerSchedule
                year={year}
                month={month}
                dispatch={dispatch}
                shiftRecord={shiftRecord}
                siteList={siteList}
                positionList={positionList}
                user={user}
                sessionConfig={sessionConfig} />
            </div>
          )}
          
      </div>
    )
  }
}

export default MonthSchedulePanel;



// WEBPACK FOOTER //
// ./src/components/Worker/MonthSchedulePanel.js